import { render, staticRenderFns } from "./WhatAInight.vue?vue&type=template&id=1f0a7b8c&scoped=true&"
import script from "./WhatAInight.vue?vue&type=script&lang=js&"
export * from "./WhatAInight.vue?vue&type=script&lang=js&"
import style0 from "./WhatAInight.vue?vue&type=style&index=0&id=1f0a7b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a7b8c",
  null
  
)

export default component.exports